import { Dropdown } from '@delmonicos/shared-design-system-react/src/components/dropdown/dropdown';
import { TextInput } from '@delmonicos/shared-design-system-react/src/components/input/text-input';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Toggle } from '@delmonicos/shared-design-system-react/src/components/toggle/toggle';
import { UpdateEmspUserOcpiTokenBodyModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/emsp-users/update-emsp-user-ocpi-token-body.model';
import { EmspUserTokenType } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/enums/emsp-user-token-type.enum';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const EmspBoEmspUserOcpiTokenUpdateFormStep1Controller =
  (): React.JSX.Element => {
    // CONTEXT /////////////////////////////////////////////////////////////////

    const { t } = useTranslation();
    const { control } = useFormContext<UpdateEmspUserOcpiTokenBodyModel>();

    // CONTEXT /////////////////////////////////////////////////////////////////

    return (
      <Stack direction="column" gap={GapEnum.M}>
        <Controller
          name="type"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <Dropdown
              label={t(
                'delmonicos-shared-sdk.outputs-emsp-user-ocpi-token.type',
              )}
              placeholder={t(
                'delmonicos-shared-sdk.outputs-emsp-user-ocpi-token.type',
              )}
              errorMessage={error?.message}
              value={field.value}
              onChange={(value) => field.onChange(value)}>
              {Object.values(EmspUserTokenType).map((type) => (
                <Dropdown.Option key={type} value={type}>
                  {type}
                </Dropdown.Option>
              ))}
            </Dropdown>
          )}
        />
        <Controller
          name="language"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <TextInput
              label={t(
                'delmonicos-shared-sdk.outputs-emsp-user-ocpi-token.language',
              )}
              placeholder={t(
                'delmonicos-shared-sdk.outputs-emsp-user-ocpi-token.language',
              )}
              errorMessage={error?.message}
              {...field}
            />
          )}
        />
        <Controller
          name="isActivated"
          control={control}
          render={({ field }) => (
            <Toggle
              id="isActivated"
              checked={field.value === true}
              onChange={field.onChange}
              label={t(
                'delmonicos-shared-sdk.outputs-emsp-user-ocpi-token.is-activated',
              )}
            />
          )}
        />
        <Controller
          name="isRevoked"
          control={control}
          render={({ field }) => (
            <Toggle
              id="isRevoked"
              checked={field.value === true}
              onChange={field.onChange}
              label={t(
                'delmonicos-shared-sdk.outputs-emsp-user-ocpi-token.is-revoked',
              )}
            />
          )}
        />
        <Controller
          name="themeId"
          control={control}
          render={({ field }) => (
            <TextInput
              label={t(
                'delmonicos-shared-sdk.outputs-emsp-user-ocpi-token.theme-id',
              )}
              placeholder={t(
                'delmonicos-shared-sdk.outputs-emsp-user-ocpi-token.theme-id',
              )}
              {...field}
            />
          )}
        />
      </Stack>
    );
  };
